import { NskHead } from "~/components/common/head/NskHead";
import { Page } from "~/containers/specifics/admin/vendor_companies/Page";

export const PATH = "/admin/vendor_companies";

function VendorCompanies() {
	return (
		<>
			<NskHead title="Admin" />
			<Page />
		</>
	);
}

export default VendorCompanies;
